"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _invariant = _interopRequireDefault(require("invariant"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

function isModifierMap(value) {
  return (0, _isPlainObject.default)(value);
}

function buildClassModifiers(baseClassName, modifiers) {
  var initialValue = [];
  return (0, _keys.default)(modifiers).reduce(function (previousValue, currentValue) {
    var booleanValue = modifiers[currentValue];

    if (booleanValue) {
      previousValue.push("".concat(baseClassName, "--").concat(currentValue));
    }

    return previousValue;
  }, initialValue);
}

function buildClassNames(baseClassName) {
  var initialValue = [baseClassName];

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.reduce(function (previousValue, currentValue) {
    if ((0, _isEmpty.default)(currentValue)) {
      return previousValue;
    }

    if ((0, _isString.default)(currentValue)) {
      return previousValue.concat(currentValue);
    }

    if (isModifierMap(currentValue)) {
      return previousValue.concat(buildClassModifiers(baseClassName, currentValue));
    }

    return previousValue;
  }, initialValue).join(' ');
}

var BemHelper = /*#__PURE__*/function () {
  function BemHelper(block) {
    (0, _classCallCheck2.default)(this, BemHelper);
    this.base = block;

    if (process.env.NODE_ENV !== 'production') {
      if (!(0, _isString.default)(block)) {
        (0, _invariant.default)(false, 'A block class name of type string must be specified.');
      }
    }
  }

  (0, _createClass2.default)(BemHelper, [{
    key: "block",
    value: function block() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return buildClassNames.apply(void 0, [this.base].concat(args));
    }
  }, {
    key: "element",
    value: function element(_element2) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return buildClassNames.apply(void 0, ["".concat(this.base, "__").concat(_element2)].concat(args));
    }
  }], [{
    key: "block",
    value: function block(_block) {
      var instance = new BemHelper(_block);

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return instance.block.apply(instance, args);
    }
  }, {
    key: "element",
    value: function element(block, _element) {
      var instance = new BemHelper(block);

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return instance.element.apply(instance, [_element].concat(args));
    }
  }]);
  return BemHelper;
}();

var _default = BemHelper;
exports.default = _default;